import { Link } from 'react-router-dom'
import { PATHS } from '../../../shared/config/paths'
import type { GuideTopic } from '../model/topics'

export const TopicCard = ({ topic }: { topic: GuideTopic }) => {
  const Icon = topic.icon
  const body = (
    <>
      <Icon size={20} aria-hidden className="shrink-0" />
      <span className="flex-1 text-base font-bold">{topic.title}</span>
      {!topic.ready && (
        <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[13px] text-gray-500">Bald</span>
      )}
    </>
  )

  if (!topic.ready) {
    return (
      <div className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white/60 px-4 py-3 text-gray-400">
        {body}
      </div>
    )
  }

  return (
    <Link
      to={PATHS.userGuideTopic.replace(':slug', topic.slug)}
      className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 text-primary transition-colors hover:border-primary"
    >
      {body}
    </Link>
  )
}
